import { FC } from 'react';
import InvoiceCustomer from './InvoiceCustomer';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectInvoiceCustomer, updateInvoiceCustomer } from 'containers/invoices/InvoicesSlice';
import { Customer } from 'containers/invoices/invoices.model';

interface CreateInvoiceCustomerProps {
  className?: string;
  context: React.Context<any>;
}

const CreateInvoiceCustomer: FC<CreateInvoiceCustomerProps> = ({ context }) => {
  const selectedCustomer = useAppSelector(selectInvoiceCustomer);

  const dispatch = useAppDispatch();

  const onUpdateServiceAddress = address => {
    const currentCustomer: Customer = { ...selectedCustomer, serviceAddress: address ? [address] : [] };
    dispatch(updateInvoiceCustomer(currentCustomer));
  };

  const onUpdateCustomer = customer => {
    dispatch(updateInvoiceCustomer(customer));
  };

  const onUpdateBillingAddress = address => {
    const currentCustomer: Customer = { ...selectedCustomer, billingAddress: address };
    dispatch(updateInvoiceCustomer(currentCustomer));
  };

  return (
    <div>
      <InvoiceCustomer
        isInvoiceEdit={false}
        selectedBillingAddress={selectedCustomer?.billingAddress}
        selectedCustomer={selectedCustomer}
        selectedServiceAddress={selectedCustomer?.serviceAddress?.[0]}
        onUpdateBillingAddress={onUpdateBillingAddress}
        onUpdateCustomer={onUpdateCustomer}
        onUpdateServiceAddress={onUpdateServiceAddress}
        context={context}
      />
    </div>
  );
};

export default CreateInvoiceCustomer;
